'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _static = require('inline-style-prefixer/static');

var _static2 = _interopRequireDefault(_static);

var _decamelize = require('./utils/decamelize');

var _decamelize2 = _interopRequireDefault(_decamelize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var prefixRegex = /^(Webkit|ms|Moz|O)/;
/**
 * Adds vendor prefixes to properties and values.
 */

function prefixer(property, value) {
  var rules = (0, _static2.default)(_defineProperty({}, property, value));
  var rulesArray = [];
  var propertyNames = Object.keys(rules); // Convert rules object to an array

  for (var i = 0; i < propertyNames.length; i++) {
    var propertyName = propertyNames[i]; // Add a dash in front of the prefixes

    var prefixedProp = propertyName.match(prefixRegex) ? '-' + propertyName : propertyName;
    var prop = (0, _decamelize2.default)(prefixedProp);
    var values = rules[propertyName]; // Handle prefixed values

    if (Array.isArray(values)) {
      for (var _i = 0; _i < values.length; _i++) {
        rulesArray.push({
          property: prop,
          value: values[_i]
        });
      }
    } else {
      rulesArray.push({
        property: prop,
        value: values
      });
    }
  }

  return rulesArray;
}